import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import { getHTML, getRichText } from '../../core';

import './footer.scss'

const FooterLink = ({ children, href, to, ...rest}) => (
  <li styleName='footer-link'>
    {href || (to.indexOf('http') > -1)
      ? <a href={href || to} {...rest}>{children}</a>
      : <Link to={to} {...rest}>{children}</Link>
    }
  </li>
)

class Footer extends React.Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allContentfulSiteFooter {
              edges {
                node {
                  editableContent {
                    json
                  }
                  image {
                    file {
                      url
                    }
                  }
                  navigationLinks {
                    text
                    link
                  }
                  socialLinks {
                    text
                    link
                    image {
                      file {
                        url
                      }
                    }
                  }
                  externalLinks {
                    text
                    link
                    image {
                      file {
                        url
                      }
                    }
                    backgroundImage {
                      resize(width: 800) {
                        src
                      }
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const footer = data.allContentfulSiteFooter.edges[0].node
          const navigationLinks = footer.navigationLinks || []
          const socialLinks = footer.socialLinks || []
          const externalLinks = footer.externalLinks || []

          return (
            <footer styleName='footer'>
              <div styleName='footer-inner '>
                <div styleName='footer-inner-box'>
                  <img 
                    styleName="image"
                    src={footer.image && footer.image.file.url} 
                  />

                  <section styleName='footer-text'>
                    {getRichText(footer.editableContent)}

                    <ul styleName='social-links'>
                      {socialLinks.map((link, i) => (
                        <FooterLink key={i} to={link.link}>
                          <div 
                            styleName="link-image"
                            style={{ backgroundImage: `url(${link.image && link.image.file.url})`}} 
                          />
                        </FooterLink>
                      ))}
                    </ul>
                  </section>

                  <ul styleName='footer-links'>
                    {navigationLinks.map((link, i) => (
                      <FooterLink key={i} to={link.link}>
                        {link.text}
                      </FooterLink>
                    ))}
                  </ul>
                </div>
              </div>

              <ul styleName='external-links'>
                {externalLinks.map((link, i) => (
                  <FooterLink key={i} href={link.link}>
                    <div 
                      styleName="link-image"
                      style={{ backgroundImage: `url(${link.backgroundImage && link.backgroundImage.resize.src})`}} 
                    />
                    <img src={link.image && link.image.file.url} />
                  </FooterLink>
                ))}
              </ul>
            </footer>
          )       
        }}
      />
    )
  }
}

export default Footer